/**
 * Bingo Scheduler Controls Model
 */

define(function(require, exports, module) {
    'use strict';

    var BaseModel = require('common/base.model');

    module.exports = BaseModel.extend({

        initialize: function(options) {
            this.options = options;
        },

        defaults: {

            controls: {
                filters: ['scheduleDay', 'schedulePeriod']
            },

            scheduleDay: {
                options: ['day-2', 'day-3', 'day-4', 'day-5', 'day-6', 'day-7', 'day-1'],
                serverMap: {
                    'day-1' : 1,
                    'day-2' : 2,
                    'day-3' : 3,
                    'day-4' : 4,
                    'day-5' : 5,
                    'day-6' : 6,
                    'day-7' : 7
                }
            },

            schedulePeriod: {
                options: ['hour-1', 'hour-2', 'hour-3', 'hour-4', 'hour-5', 'hour-6'],
                serverMap: {
                    'hour-1' : 6,
                    'hour-2' : 1,
                    'hour-3' : 2,
                    'hour-4' : 3,
                    'hour-5' : 4,
                    'hour-6' : 5
                }
            },

            viewModes: {
                options: ['IMAGE', 'LIST', 'SHORT']
            }

        }

    });
});
